// Static fallback images for landing preview — same ones used by the real frontend
import bg1 from '/assets/bg1.jpg'
import bg2 from '/assets/bg2.jpg'
import bg3 from '/assets/bg3.jpg'
import bg4 from '/assets/bg4.jpg'
import imgPanjang from '/assets/img_panjang.jpg'
import bgHero1 from '/assets/bg-hero-1.jpg'
import logoDark from '/assets/logo_dark.png'
import logoBg from '/assets/logo_bg.png'
import logIppnu1 from '/assets/log_ippnu_res.png'
import logIppnu2 from '/assets/log_kongres_ippnu.png'
import foto1 from '/assets/foto_diri_formal_689c4047bec90.jpg'
import foto3 from '/assets/foto_diri_formal_68b1114c78dbf.jpg'
import foto4 from '/assets/foto_diri_formal_68be5d7aa8d2b.jpeg'
import placeholder from '/assets/placeholder.png'
import basicN4 from '/assets/basic_n4.jpg'
import basicN5 from '/assets/basic_n5.jpg'
import kegiatan1 from '/assets/kegiatan_1.jpeg'
import kegiatan2 from '/assets/kegiatan_2.jpeg'
import kegiatan3 from '/assets/kegiatan_3.jpeg'
import kegiatan4 from '/assets/kegiatan_4.jpeg'
import jobImg from '/assets/Job.jpeg'
import pengantaranImg from '/assets/Pengantaran.jpeg'
import pengantaran2Img from '/assets/Pengantaran2.jpeg'
import persiapanImg from '/assets/Persiapan.jpeg'
import pertemuanImg from '/assets/Pertemuan.jpeg'
import pembekalanImg from '/assets/Pembekalan.jpeg'
import ippnu1 from '/assets/ippnu_ponorogo.jpeg'
import ippnu2 from '/assets/ippnu_ponorogo2.jpeg'

export const DEFAULT_HERO = [bg1, bg2, bg3, bg4]
export const DEFAULT_ABOUT = [imgPanjang, bg1, bg4]

export const DEFAULT_CLIENTS = [
  { id: 'd1', name: 'IPNU PONOROGO', logo: logIppnu1 },
  { id: 'd2', name: 'KONGRES IPPNU', logo: logIppnu2 },
]

export const DEFAULT_SCHEDULE = [
  { id: 's1', title: 'Kelas Basic N4', deskripsi: 'Kelas Basic direkomendasikan bagi peserta yang memiliki keinginan untuk siap bekerja di Jepang. Kelas BASIC meliputi pendidikan dasar bahasa Jepang serta Budaya dan etika di negara Jepang.', kategori: ['Bahasa Jepang', 'N4 Level', 'Percakapan', 'Kanji Dasar'], rating: 4.9, image_url: basicN4, duration: '6 Bulan Pendidikan', certified: true, reviews: 156 },
  { id: 's2', title: 'Kelas Basic N5', deskripsi: 'Kelas Basic direkomendasikan bagi peserta yang memiliki keinginan untuk siap bekerja di Jepang. Kelas BASIC meliputi pendidikan dasar bahasa Jepang serta Budaya dan etika di negara Jepang.', kategori: ['Sertifikat Kompetensi', 'N5 Level'], rating: 4.8, image_url: basicN5, duration: '6 Bulan Pendidikan', certified: true, reviews: 89 },
]

export const DEFAULT_TEAM = [
  { id: 't1', title: 'Marketing', subtitle: 'UDIN, S.Sos.I', description: 'Visi: "MENAMPUNG SISWA SISWI YANG BERMINAT KERJA KE JEPANG YANG TIDAK MAU KULIAH"', url: foto1 },
  { id: 't2', title: 'Marketing', subtitle: 'Gangsar', description: 'Visi: "Menambah relasi dan pengalaman"', url: placeholder },
  { id: 't3', title: 'Marketing', subtitle: 'Arwindha pupy choirunnisa', description: 'Visi: "Mendapat penghasilan tambahan, mempromosikan dan meyebarluaskan tawaran kerja di jepang "', url: foto3 },
  { id: 't4', title: 'Marketing', subtitle: 'RUSBIYANTO', description: 'Visi: "ikut andil dalam mengurangi pengganguran dan meningkatkan pendapatan ekonomi di wilayah saya"', url: foto4 },
]

export const DEFAULT_GALLERY = [
  { id: 'g1', title: 'Job Fair di PCC PONOROGO', url: jobImg },
  { id: 'g2', title: 'Pengantaran Peserta Didik ke Jepang', url: pengantaranImg },
  { id: 'g3', title: 'Pengantaran Peserta Didik ke Jepang', url: pengantaran2Img },
  { id: 'g4', title: 'Pertemuan Dengan Pejabat Jepang', url: persiapanImg },
  { id: 'g5', title: 'Pertemuan dengan pejabat penting Jepang', url: pertemuanImg },
  { id: 'g6', title: 'Persiapan Pembekalan Peserta Didik', url: pembekalanImg },
  { id: 'g7', title: 'Kerjasama Dengan IPNU PONOROGO', url: ippnu1 },
  { id: 'g8', title: 'Kerjasama Dengan IPNU PONOROGO', url: ippnu2 },
]

export const WA_NUMBER = '6281395554334'

// Static image refs (no CMS fallback)
export const ASSETS = {
  imgPanjang, bgHero1, logoDark, logoBg,
}
